// extracted by css-extract-rspack-plugin
export default {"root":"NH6x5z","placeholder-text":"dRr_Am","placeholderText":"dRr_Am"};